import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../api/api";

const ProtectedRoute = ({ children, role }) => {
  const [status, setStatus] = useState("loading"); 
  const [user, setUser] = useState(null);

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      try {
        const res = await api.get("/auth/me");
        if (!mounted) return;

        setUser(res.data);
        setStatus("authenticated");
      } catch {
        if (!mounted) return;
        setStatus("unauthenticated");
      }
    };

    checkAuth();

    return () => {
      mounted = false;
    };
  }, []);

  if (status === "loading") return null;

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  if (role && user?.role !== role) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
